//
// Login:
//

export const index = {
    path   : '/profit_sharings/reports/per_user/',
    method : 'GET',
    version: '/v1'
}
